import { Input } from 'antd';
import Colors from 'assets/Colors';

function CustomInput(props) {
  return (
    <Input.TextArea
      {...props}
      style={{
        height: '40px',
        width: '100%',
        borderColor: props.value ? Colors.primary : Colors.background_dividers,
        borderRadius: '5px',
        borderStyle: 'solid',
        ...props.style,
      }}
    />
  );
}

export default CustomInput;
